<template>
  <datepicker
    v-model="selectedValue"
    class="pa-2 month-picker"
    starting-view="month"
    minimum-view="month"
    :upper-limit="upperLimit"
    :lower-limit="lowerLimit"
    input-format=" yyyy年MM月     ▼"
    :locale="ja"
    @update:model-value="onMonthChange"
  />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue"
import datepicker from "vue3-datepicker"
import ja from "date-fns/locale/ja"

export default defineComponent({
  name: "MonthPickerPart",
  components: {
    datepicker
  },
  props: {
    selectedDate: {
      type: Date,
      required: true
    },
    maxMonth: Date,
    minMonth: Date,
  },
  emits: ["on-month-changed"],
  setup(props, { emit }) {
    const selectedValue = ref<Date>(props.selectedDate as Date)

    const onMonthChange = (val: Date) => {
      emit("on-month-changed", val)
    }
    const upperLimit = ref<Date>(props.maxMonth ? (props.maxMonth as Date) : new Date())
    const lowerLimit = ref<Date>(props.minMonth ? (props.minMonth as Date) : new Date("2022-03-01"))

    return {
      ja,
      selectedValue,
      upperLimit,
      lowerLimit,
      onMonthChange
    }
  }
})
</script>
<style lang="scss">
  .v3dp__datepicker {
    /** See: https://icehaunter.github.io/vue3-datepicker/config.html#styling-example-and-playground */
    --vdp-hover-bg-color: #3ACAC9;
    --vdp-selected-bg-color: #3ACAC9;
    --vdp-text-color: #222;
  }
</style>

<style>
.v3dp__datepicker {
  .v3dp__input_wrapper input {
    background: #fff;
    border-radius: 5px;
    width: 130px;
    border: 1px solid #ddd;
    font-size: 14px !important;
    font-weight: bold;
    color: #222;
  }
}
.picker-align-right {
  .v3dp__popout{
    right: 0
  }
}
.v3dp__popout {
  /* カレンダー部の文字サイズがカレンダー定義箇所に影響されないようにする */
  font-size: 1rem;
}
</style>
